<template>
    <div>
        <div v-if="showControls" class="buttons has-addons">
            <button class="button" @click="$emit('click', { type: 'answer' })">
                <span class="icon">
                    <i class="fas fa-question" />
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showControls: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
button {
    border: unset !important;
}
</style>
